import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { trackAddToCart, trackInitiateCheckout } from '../utils/metaPixel';
const CART_URL = 'https://checkout.volveaserdeseada.com/cart/add?id=42732657344599&quantity=1&return_to=%2Fcart';
const INITIAL_SECONDS = 20 * 60; // 20 minutes
function useFinalCountdown() {
  const [timeLeft, setTimeLeft] = useState(INITIAL_SECONDS);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev <= 0 ? INITIAL_SECONDS : prev - 1);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  const pad = (n: number) => n.toString().padStart(2, '0');
  return `${pad(minutes)}:${pad(seconds)}`;
}
export function FinalCTA() {
  const display = useFinalCountdown();
  return <section className="bg-gradient-to-br from-burgundy to-burgundy/90 py-10 md:py-16 px-5" data-id="element-42">
      <div className="max-w-2xl mx-auto text-center" data-id="element-43">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-44">
          <h2 className="font-playfair text-[26px] md:text-4xl lg:text-5xl font-bold text-white mb-5 md:mb-6 leading-tight" data-id="element-45">
            Hoy podés decidir
            <br data-id="element-46" />
            <span className="italic font-light" data-id="element-47">volver a vos.</span>
          </h2>

          {/* Compact emotional block */}
          <div className="mb-6 space-y-2" data-id="element-48">
            <p className="text-[15px] md:text-lg text-white/85 italic leading-relaxed" data-id="element-49">
              Imaginá despertarte mañana sintiéndote deseada otra vez.
            </p>
            <p className="text-[15px] md:text-lg text-white/85 italic leading-relaxed" data-id="element-50">
              Imaginá esa mirada que te hacía sentir única.
            </p>
            <p className="text-[15px] md:text-lg text-white/85 italic leading-relaxed" data-id="element-51">
              Imaginá dejar de dudar de vos misma.
            </p>
            <p className="text-base md:text-xl text-white font-semibold pt-2" data-id="element-52">
              Todo eso empieza con una sola decisión.
            </p>
          </div>

          {/* Compact offer block */}
          <div className="bg-white/10 backdrop-blur-sm py-4 px-5 rounded-xl mb-6" data-id="element-53">
            <p className="text-[14px] md:text-base text-white leading-relaxed" data-id="element-54">
              Accedé al programa{' '}
              <span className="font-bold" data-id="element-55">Volvé a Ser Deseada</span> con{' '}
              <span className="font-bold text-gold" data-id="element-56">50% OFF</span> + todos los
              bonus incluidos.
            </p>
          </div>

          {/* CTA */}
          <a href={CART_URL} onClick={() => {
          trackAddToCart();
          trackInitiateCheckout();
        }} className="inline-block bg-white hover:bg-white/95 text-burgundy font-bold text-base md:text-xl px-8 md:px-12 py-4 md:py-5 rounded-full shadow-xl transition-all duration-300 transform hover:scale-[1.02]" data-id="element-57">
            Quiero volver a sentirme deseada →
          </a>

          {/* Countdown 20 min MM:SS */}
          <motion.p key={display} initial={{
          scale: 1.05,
          opacity: 0.85
        }} animate={{
          scale: 1,
          opacity: 1
        }} transition={{
          type: 'spring',
          stiffness: 300,
          damping: 22
        }} className="text-white/90 font-medium text-[13px] md:text-sm mt-4" data-id="element-58">
            ⏰ Esta oferta termina en{' '}
            <span className="font-mono font-bold tabular-nums" data-id="element-59">{display}</span>
          </motion.p>

          {/* Benefits row — compact */}
          <div className="mt-5 flex flex-wrap justify-center gap-x-4 gap-y-1.5 text-white/80 text-[12px] md:text-sm" data-id="element-60">
            <span data-id="element-61">✓ Acceso inmediato</span>
            <span data-id="element-62">✓ Garantía 7 días</span>
            <span data-id="element-63">✓ Bonus incluidos</span>
          </div>
        </motion.div>
      </div>
    </section>;
}